import { useTranslations } from "use-intl";

export function useDocumentsTranslations() {
  return useTranslations("Documents");
}
